import { settings } from '../../../engine/settings-sidecar'
import { l } from '../../../lib/imports'
import { common } from '../../../main/common-sidecar'
import { golfLayers } from '../golfLayers-sidecar'
import { golfPhysics } from './golfPhysics-sidecar'

let _graphics: Phaser.GameObjects.Graphics | null = null
let _debugMouseRaycast = false

export function toggleDebugEnabled() {
  settings.update({ physicsShowDebug: !settings.get().physicsShowDebug })
}

// export function create() {}
const _bodies: planck.Body[] = []
export function addBody(body: planck.Body) {
  _bodies.push(body)
}
export function removeBody(body: planck.Body) {
  l.pull(_bodies, body)
}

// const _raycastResults: IGoatRaycastClosest[] = []
// export function addRaycast(rcc: IGoatRaycastClosest) {
//   _raycastResults.push(rcc)
// }
// export function removeRaycast(rcc: IGoatRaycastClosest | null) {
//   if (rcc) {
//     l.pull(_raycastResults, rcc)
//   }
// }

export function updateAll() {
  if (!settings.get().physicsShowDebug) {
    if (_graphics) {
      _graphics.visible = false
    }
    return
  }
  // console.log('update physics debug')
  let thickness = 1
  let colorAwake = 0x00ff00
  let colorSleep = 0x009900
  let colorStatic = 0xcccccc
  let colorSensor = 0x0000cc
  let alpha = 0.5

  if (!_graphics) {
    let sc = common.getPhaserScene()
    _graphics = sc.add.graphics()
    let layer = golfLayers.getLayers().debugPhysics
    layer.add(_graphics)
  }

  _graphics.clear()
  _graphics.visible = true
  let g = _graphics

  g.lineStyle(5, 0xff0000, 0.5)
  //g.strokeCircle(10, 10, 20)

  //g.moveTo(0, 0)
  //g.lineStyle(2, colorAwake, alpha)
  //g.strokeRect(100, 100, 400, 400)
  // g.strokeCircle(150, 150, 5)
  //   console.log('debugging physics', _bodies.length)

  // console.log('body count', _bodies.length)
  l.forEach(_bodies, (c, cIdx) => {
    // g.lineStyle(thickness, colorAwake, alpha)

    if (c.isActive()) {
      let v = c.getPosition()
      let f = c.getFixtureList()
      let color = colorAwake

      if (!c.isDynamic()) {
        color = colorStatic
      } else if (!c.isAwake()) {
        color = colorSleep
      } else {
        color = colorAwake
      }
      // g.lineStyle(thickness, color, alpha)
      if (f) {
        if (f.isSensor()) {
          // g.lineStyle(thickness, colorSensor, alpha)
        }
        let s = f.getShape()
        let st = s.getType()
        let x = v.x * golfPhysics.worldScale
        let y = v.y * golfPhysics.worldScale
        // g.moveTo(x, y)
        // console.log('draw circle', x, y, s.getRadius())
        if (st === 'circle') {
          g.strokeCircle(x, y, s.getRadius() * golfPhysics.worldScale)
          // if (cIdx === 0) {
          //   console.log(x, y, s.getRadius() * physics.worldScale)
          // }
        }
        if (st === 'polygon') {
          // g.setRotation(c.getAngle())
          let poly = s as planck.Polygon
          g.beginPath()
          for (let i = 0; i < poly.m_vertices.length; i++) {
            let v2 = poly.m_vertices[i]
            // console.log(
            //   'poly',
            //   x,
            //   y,
            //   i,
            //   v2.x * golfPhysics.worldScale,
            //   v2.y * golfPhysics.worldScale,
            // )
            if (i === 0) {
              g.moveTo(
                v2.x * golfPhysics.worldScale + x,
                v2.y * golfPhysics.worldScale + y,
              )
            } else {
              g.lineTo(
                v2.x * golfPhysics.worldScale + x,
                v2.y * golfPhysics.worldScale + y,
              )
            }
          }
          g.closePath()
          g.strokePath()
        }
      }
    }
  })

  // if (_debugMouseRaycast) {
  //   let rcc = physicsRaycast.RayCastClosestMouse(0)
  //   physicsRaycast.RaycastClosestDebug(g, rcc)
  // }

  // l.forEach(_raycastResults, (c) => {
  //   physicsRaycast.RaycastClosestDebug(g, c)
  // })
}
